<app-dialog
	modalTitle="Cesta de Produtos"
	titleButton="Salvar configurações"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="saveProducts()"
>
	<mat-form-field class="filter-products" appearance="outline">
		<input
			type="text"
			matInput
			placeholder="Buscar produtos"
			[formControl]="filterProductsControl"
			(keyup)="filterProductsList()"
		/>
		<button
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Filter products"
			(click)="filterProductsList()"
		>
			<mat-icon>search</mat-icon>
		</button>
	</mat-form-field>
	<ul>
		<li>
			<mat-checkbox
				color="primary"
				class="ml-xs"
				[checked]="masterSelection()"
				(change)="onMasterToggle()"
			>
				Selecionar todos os produtos
			</mat-checkbox>
		</li>
		<li>
			<div class="separator"></div>
		</li>
		<li *ngFor="let product of data.products; let idx = index">
			<mat-checkbox
				color="primary"
				class="ml-xs mt-quark mb-quark"
				[checked]="selectedProducts.includes(product.id)"
				(change)="onPositionToggle(product.id, $event.checked)"
			>
				{{ product.name }}
			</mat-checkbox>
		</li>
	</ul>
</app-dialog>
